module.exports = __webpack_public_path__ + "static/media/background_beer.84193d0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background_beer.jpg
// module id = 193
// module chunks = 0